import { Injectable } from '@angular/core';
import { BigCommerceModeStateService } from '@app/core/services/bigcommerce-mode-state.service';

@Injectable({
    providedIn: 'root'
})
export class ProductTerminologyService {

    get exportGroupText(): 'transformed data' | 'channel catalogs' {
        if (this.bigCommerceMode.showRestrictedUI()) {
            return 'channel catalogs';
        }
        return 'transformed data';
    }

    get exportText(): 'export' | 'channel' {
        if (this.bigCommerceMode.showRestrictedUI()) {
            return 'channel';
        }
        return 'export';
    }

    get fieldText(): 'field' | 'attribute' {
        if (this.bigCommerceMode.showRestrictedUI()) {
            return 'attribute';
        }
        return 'field';
    }

    get fqlFunctionText(): 'transformer function' | 'rule function' {
        if (this.bigCommerceMode.showRestrictedUI()) {
            return 'rule function';
        }
        return 'transformer function';
    }

    get generalExportText(): 'general export' | 'product catalog' {
        if (this.bigCommerceMode.showRestrictedUI()) {
            return 'product catalog';
        }
        return 'general export';
    }

    get importAction(): 'import' | 'manual sync' {
        if (this.bigCommerceMode.showRestrictedUI()) {
            return 'manual sync';
        }
        return 'import';
    }

    get importText(): 'import' | 'data source' {
        if (this.bigCommerceMode.showRestrictedUI()) {
            return 'data source';
        }
        return 'import';
    }

    get rawDataText(): 'raw data' | 'source data' {
        if (this.bigCommerceMode.showRestrictedUI()) {
            return 'source data';
        }
        return 'raw data';
    }

    get rowsText(): 'rows' | 'products' {
        if (this.bigCommerceMode.showRestrictedUI()) {
            return 'products';
        }
        return 'rows';
    }

    get transformationText(): 'transformation' | 'rule' {
        if (this.bigCommerceMode.showRestrictedUI()) {
            return 'rule';
        }
        return 'transformation';
    }

    get transformerText(): 'transformer' | 'rule' {
        if (this.bigCommerceMode.showRestrictedUI()) {
            return 'rule';
        }
        return 'transformer';
    }

    constructor(
        private readonly bigCommerceMode: BigCommerceModeStateService
    ) {}

    /*
     * adds a singular article to any of the terminology in this file.
     * This will only have exceptions for terms within this file, and should
     * not be generally used.
     */
    addSingularArticleToTerm(text: string): string {
        if (['a', 'e', 'i', 'o', 'u'].includes(text[0])) {
            return `an ${text}`;
        }
        return `a ${text}`;
    }
}
